import React from 'react';
import { LabelWithTooltip } from './Tooltip';

function PlaqueDimensionsForm({ dimensions, onChange }) {
  return (
    <div className="card">
      <div className="card-header">
        <h2>Dimensions des plaques</h2>
      </div>
      
      <div className="form-group">
        <LabelWithTooltip 
          htmlFor="plaque-largeur"
          label="Largeur (cm)"
          tooltip="Largeur standard d'une plaque de placoplatre (généralement 120cm)"
        />
        <div className="input-group">
          <input
            id="plaque-largeur"
            type="number"
            className="form-control"
            value={dimensions.largeur}
            onChange={(e) => onChange({
              ...dimensions,
              largeur: parseInt(e.target.value) || 0
            })}
          />
          <div className="input-group-append">cm</div>
        </div>
      </div>
      
      <div className="form-group">
        <LabelWithTooltip 
          htmlFor="plaque-hauteur"
          label="Hauteur (cm)"
          tooltip="Hauteur standard d'une plaque (généralement 250cm ou 300cm)"
        />
        <div className="input-group">
          <input
            id="plaque-hauteur"
            type="number"
            className="form-control"
            value={dimensions.hauteur}
            onChange={(e) => onChange({
              ...dimensions,
              hauteur: parseInt(e.target.value) || 0
            })}
          />
          <div className="input-group-append">cm</div>
        </div>
      </div>
    </div>
  );
}

export default PlaqueDimensionsForm;